import { lruMemoize } from 'reselect';

import {
    isResourceLoading,
    isResourceFailed,
    isResourceComplete,
    getResourceError,
} from './common';

const isCollateralTemplateLoading = lruMemoize(isResourceLoading);
const isCollateralTemplateFailed = lruMemoize(isResourceFailed);
const isCollateralTemplateComplete = lruMemoize(isResourceComplete);

const getCollateralTemplateData = (state) => state.getIn(['app', 'collateralTemplate']);

const getCollateralTemplate = lruMemoize((data) => data.get('collateralTemplate'));
const getCollateralTemplateError = lruMemoize(getResourceError);

export {
    isCollateralTemplateLoading,
    getCollateralTemplateError,
    isCollateralTemplateFailed,
    isCollateralTemplateComplete,
    getCollateralTemplateData,
    getCollateralTemplate,
};
